import { StaticRepository } from "../../api/repositories/cdn/static"
import { GameStage } from "../../api/repositories/stats/models/item-builds"
import { getGlobalstate, setGlobalState } from "../hooks/global-state"

export const Languages: readonly Language[] = ["en", "ru"]

let localization: Localization;

export function isAvailableLanguage(lang: string): lang is Language {
	return Languages.includes(lang as Language)
}

export function changeLanguage() {
	const lang = getGlobalstate("language")

	if (lang) {
		const newLang = lang == 'ru' ? 'en' : 'ru'
		setLanguage(newLang);
	} else {
		setLanguage('en')
	}
}

export function setLanguage(lang: Language) {
	if (isAvailableLanguage(lang)) {
		localStorage.setItem("language", lang)
		setGlobalState("language", lang)
	}
}

export function getLanguage() {
	return getGlobalstate("language");
}

export function localize(key: string): string {
	const lang = getGlobalstate("language") || "en"
	const value = localization[key]

	return (value && value[lang]) || key
}

export function localizePrice(price: number | string, currency: Currency) {
	return `${price} ${localizeCurrencySymbol(currency)}`;
}

export function localizeCurrencySymbol(currency: Currency) {
	switch (currency) {
		case "usd":
			return "$";
		case "rub":
			return "₽";
		case "eur":
			return "€";
	}
}

export async function initLocalization() {
	const saved = localStorage.getItem("language")

	if (saved && isAvailableLanguage(saved)) {
		setLanguage(saved)
	} else if (window.navigator.language) {
		const browserLang = window.navigator.language.slice(0, 2);

		if (isAvailableLanguage(browserLang))
			setLanguage(browserLang)
		else
			setLanguage("ru")
	}
	else {
		setLanguage("ru")
	}

	const staticRepository = new StaticRepository();

	localization = await staticRepository.getLocalization();
}

export function localizeTimeAgo(count: number, type: "day" | "week" | "hour") {
	const lang = getLanguage();
	const isEnLang = lang == "en";

	let value;
	switch (type) {
		case "day":
			value = isEnLang
				? getUpdateAgoEnValue(count, "dota_update_days_ago")
				: getUpdateAgoRuValue(count, "dota_update_days_ago");
			break;

		case "week":
			value = isEnLang
				? getUpdateAgoEnValue(count, "dota_update_weeks_ago")
				: getUpdateAgoRuValue(count, "dota_update_weeks_ago");
			break;

		case "hour":
			value = isEnLang
				? getUpdateAgoEnValue(count, "dota_update_hours_ago")
				: getUpdateAgoRuValue(count, "dota_update_hours_ago");
			break;
	}

	return isEnLang ? value + " ago" : value + " назад";
}

export function getGameStage(gameStage: GameStage): string {
	switch (gameStage) {
		case 'start':
			return localize('dota_game_stage_start');
		case 'early':
			return localize('dota_game_stage_early');
		case 'mid':
			return localize('dota_game_stage_mid');
		case 'late':
			return localize('dota_game_stage_late');
	}
}

export function getUpdateAgoEnValue(count: number, value: string) {
	const values = localize(value).split("|");

	return count > 1
		? values[0]
		: values[1];
}

export function getUpdateAgoRuValue(count: number, value: string) {
	const values = localize(value).split("|");
	const countLastNumber = parseInt(count.toString().slice(-1));

	switch (countLastNumber) {
		case 1:
			return values[0];
		case 2:
		case 3:
		case 4:
			return values[1];
		default:
			return values[2];
	}
}

export function getByLocalization(ru?: string, eng?: string): string | undefined {
	const lang = getLanguage();
	switch (lang) {
		case "en":
			return eng;
		case "ru":
			return ru;
		default:
			return undefined
	}
}

export function getByLocalizationRows(ru: string[], eng: string[]): string[] {
	const lang = getLanguage();
	switch (lang) {
		case "en":
			return eng;
		case "ru":
			return ru;
		default:
			return []
	}
}